export const TABLE = 
{
  "teams":[
  {
  "name":"Spartakus Radgoszcz",
  "pts":"31",
  "won":"10",
  "draws":"1",
  "lost":"0",
  "score":"46-13",
  "pos":"1.",
  "matches":"11"
  },
  {
  "name":"Brzoza Brzezówka",
  "pts":"24",
  "won":"8",
  "draws":"0",
  "lost":"3",
  "score":"33-19",
  "pos":"2.",
  "matches":"11"
  },
  {
  "name":"MLKS II Żabno",
  "pts":"23",
  "won":"7",
  "draws":"2",
  "lost":"1",
  "score":"37-16",
  "pos":"3.",
  "matches":"10"
  },
  {
  "name":"LKS Smęgorzów",
  "pts":"20",
  "won":"6",
  "draws":"2",
  "lost":"2",
  "score":"31-16",
  "pos":"4.",
  "matches":"10"
  },
  {
  "name":"Wisła Borusowa",
  "pts":"20",
  "won":"6",
  "draws":"2",
  "lost":"2",
  "score":"27-16",
  "pos":"5.",
  "matches":"10"
  },
  {
  "name":"LZS Wójcina",
  "pts":"19",
  "won":"6",
  "draws":"1",
  "lost":"4",
  "score":"20-17",
  "pos":"6.",
  "matches":"11"
  },
  {
  "name":"Dunajec Ujście Jezuickie",
  "pts":"17",
  "won":"5",
  "draws":"2",
  "lost":"3",
  "score":"22-16",
  "pos":"7.",
  "matches":"10"
  },
  {
  "name":"LZS Olesno",
  "pts":"15",
  "won":"4",
  "draws":"3",
  "lost":"4",
  "score":"23-21",
  "pos":"8.",
  "matches":"11"
  },
  {
  "name":"Powiśle Bolesław",
  "pts":"13",
  "won":"4",
  "draws":"1",
  "lost":"5",
  "score":"32-22",
  "pos":"9.",
  "matches":"10"
  },
  {
  "name":"Dąbrovia II Dąbrowa Tarnowska",
  "pts":"12",
  "won":"4",
  "draws":"0",
  "lost":"5",
  "score":"20-25",
  "pos":"10.",
  "matches":"9"
  },
  {
  "name":"Łęgovia II Łęg Tarnowski",
  "pts":"12",
  "won":"4",
  "draws":"0",
  "lost":"7",
  "score":"18-33",
  "pos":"11.",
  "matches":"11"
  },
  {
  "name":"Orzeł Miechowice Małe",
  "pts":"9",
  "won":"2",
  "draws":"3",
  "lost":"5",
  "score":"18-25",
  "pos":"12.",
  "matches":"10"
  },
  {
  "name":"LZS Mędrzechów",
  "pts":"7",
  "won":"1",
  "draws":"4",
  "lost":"5",
  "score":"11-26",
  "pos":"13.",
  "matches":"10"
  },
  {
  "name":"Kłos Słupiec",
  "pts":"6",
  "won":"1",
  "draws":"3",
  "lost":"6",
  "score":"22-36",
  "pos":"14.",
  "matches":"10"
  },
  {
  "name":"DTS Dąbrowa Tarnowska",
  "pts":"6",
  "won":"1",
  "draws":"3",
  "lost":"6",
  "score":"10-30",
  "pos":"15.",
  "matches":"10"
  },
  {
  "name":"Polonia Kłyż",
  "pts":"6",
  "won":"2",
  "draws":"0",
  "lost":"7",
  "score":"21-46",
  "pos":"16.",
  "matches":"9"
  },
  {
  "name":"Olimpia Biskupice Radłowskie",
  "pts":"6",
  "won":"1",
  "draws":"3",
  "lost":"7",
  "score":"11-25",
  "pos":"17.",
  "matches":"11"
  }
  ]
  }